import { render, staticRenderFns } from "./receiptsettings.vue?vue&type=template&id=c7abf5ac&scoped=true"
import script from "./receiptsettings.vue?vue&type=script&lang=js"
export * from "./receiptsettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7abf5ac",
  null
  
)

export default component.exports